var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "95px",
    viewBox: "0 0 95 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ckeckmarkChecked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-Materialen",
    transform: "translate(-263.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checked-button",
    transform: "translate(263.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13",
    fill: "#FD632A",
    fillRule: "evenodd",
    cx: 47.0522908,
    cy: 47.0522908,
    r: 47.0522908
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-259",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    points: "17.878842 41.1776242 38.5662965 66.260497 76.6992473 29.5290914"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkChecked);
export default __webpack_public_path__ + "static/media/checkmarkChecked.e235d0388a9807195f6bd1c46b0ff98c.svg";
export { ForwardRef as ReactComponent };